import React from "react";
import Button from "./Button.tsx";

interface SubmitButtonProps {
  isFormValid: boolean;
  isSubmitting: boolean;
  errors: Record<string, string>;
  fieldTextStyle: React.CSSProperties;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isFormValid,
  isSubmitting,
  errors,
  fieldTextStyle,
}) => {
  return (
    <div className="mt-4 md:mt-10 flex justify-center">
      <div className="relative group">
        <Button
          type="submit"
          varient="solid"
          buttonClass="px-[30px] py-[6.5px] md:py-[6.5px] font-bold text-nowrap leading-4 h-[36px] md:h-auto"
          disabled={!isFormValid || isSubmitting}
          aria-describedby={!isFormValid ? "invalid-hint" : undefined}
          aria-busy={isSubmitting}
        >
          <span className="text-[14px] md:text-[16px]">
            {isSubmitting ? "Sending..." : "Contact Armory"}
          </span>
        </Button>
        {!isFormValid && (
          <div
            id="invalid-hint"
            className="absolute -top-12 left-1/2 -translate-x-1/2 z-10 whitespace-nowrap rounded border border-[#2972D7] bg-black/80 px-3 py-2 text-white text-sm opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity pointer-events-none"
          >
            Please complete all required fields to proceed.
            <span className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-x-[9px] border-x-transparent border-t-[9px] border-t-[#2972D7]"></span>
            <span
              className="absolute top-[calc(100%-1px)] left-1/2 -translate-x-1/2 w-0 h-0 border-x-[8px] border-x-transparent border-t-[8px]"
              style={{ borderTopColor: "rgba(0,0,0,0.8)" }}
            ></span>
          </div>
        )}
      </div>
      {errors.form && (
        <p
          role="alert"
          aria-live="assertive"
          className="text-white text-center mt-4"
          style={{
            ...fieldTextStyle,
            fontSize: 14,
            textShadow: "0px 0px 11.96px rgba(255,0,0,0.5), 0px 0px 23.92px #FF0000",
          }}
        >
          {errors.form}
        </p>
      )}
    </div>
  );
};

export default SubmitButton;
